var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{directives:[{name:"promise-btn",rawName:"v-promise-btn"}],domProps:{"textContent":_vm._s(_vm.label)},on:{"click":function($event){$event.preventDefault();return _vm.joinCampaign.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }